import img from "../US_img/1.webp"; 
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function USWallDress() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>WALLDRESS</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Habillage mural décoratif</h1>

          <p data-aos="fade-up">
            Transformez vos murs avec des solutions décoratives modernes
            combinant textures, reliefs et finitions haut de gamme.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a href="/contact" className="btn-outline">
              Nous contacter
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US WallDress habillage mural" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que US WALLDRESS ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US WALLDRESS est une solution d’habillage mural innovante permettant
            de donner du caractère à vos espaces grâce à des revêtements modernes,
            textures décoratives et effets visuels uniques.
          </p>

          <p data-aos="fade-up">
            Adaptée aux projets résidentiels et professionnels, cette solution
            valorise l’architecture intérieure avec des finitions esthétiques
            et durables.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🎨"
            title="Design élégant"
            text="Apporte une touche moderne et raffinée aux murs."
          />
          <Feature
            icon="🧱"
            title="Effets 3D & textures"
            text="Reliefs et finitions pour un rendu visuel unique."
          />
          <Feature
            icon="✨"
            title="Finition premium"
            text="Matériaux haut de gamme et durables."
          />
          <Feature
            icon="🏗️"
            title="Adaptabilité"
            text="Compatible avec tous types d’espaces."
          />
          <Feature
            icon="⚡"
            title="Installation rapide"
            text="Pose simple et efficace."
          />
          <Feature
            icon="🛠️"
            title="Entretien facile"
            text="Solutions pratiques et résistantes."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Panneaux décoratifs 3D</li>
          <li>Finitions personnalisées</li>
          <li>Matériaux innovants</li>
          <li>Installation sur murs neufs ou existants</li>
          <li>Haute résistance et durabilité</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Villas",
            "Hôtels",
            "Restaurants",
            "Commerces",
            "Bureaux",
            "Showrooms",
            "Espaces premium",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Habillez vos murs avec élégance</h2>
        <p>US WALLDRESS donne vie à vos espaces.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}